import Textarea from '@/components/basicComponents/textarea';
import Label from '@/components/basicComponents/label';
import { buildTestId } from '@/lib/utils/testIds';
import { useEffect } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { IRenderTemplateRow } from '../types';
import { evaluateDependencyItem, shouldRenderEmptyComponent } from '../utils';

interface TextareaComponentProps {
  row: IRenderTemplateRow;
  pageName?: string;
  ignoreRequired: boolean;
}

export const TextareaComponent = ({ row, pageName = '', ignoreRequired }: TextareaComponentProps) => {
  const { name, label, validation, dependsOn } = row;
  const { control, unregister, watch } = useFormContext();
  const dependentValue = dependsOn ? watch(`${pageName}.${dependsOn.name}`) : null;
  const hasValidOrDependency: boolean = dependsOn?.or
    ? dependsOn.or.some((item: any) => {
        const dependentValue = watch(`${pageName}.${item.name}`);
        return evaluateDependencyItem(dependentValue, item);
      })
    : null;
  const hasValidAndDependency: boolean = dependsOn?.and
    ? dependsOn.and.every((item: any) => {
        const dependentValue = watch(`${pageName}.${item.name}`);
        return evaluateDependencyItem(dependentValue, item);
      })
    : null;

  useEffect(() => {
    if (shouldRenderEmptyComponent(dependsOn, dependentValue, hasValidOrDependency, hasValidAndDependency)) {
      unregister(`${pageName}.${name}`);
    }
  }, [dependentValue, hasValidOrDependency, hasValidAndDependency]);

  if (shouldRenderEmptyComponent(dependsOn, dependentValue, hasValidOrDependency, hasValidAndDependency)) return <></>;

  return (
    <>
      <div>
        {label && (
          <Label size="md" required={!!validation?.required && !ignoreRequired}>
            {label}
          </Label>
        )}
        <Controller
          name={`${pageName}.${name}`}
          control={control}
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <Textarea value={value} onChange={onChange} size="md" errorText={error?.message} data-testid={name ? buildTestId('signature-packet', pageName, name) : undefined} />
          )}
        />
      </div>
    </>
  );
};
